import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, throwError } from "rxjs";
import { environment } from "../environments/environment";
import { PostUnsubscribeParametersDto } from "../models/unsubscribe/unsubscribe.model";

@Injectable({
  providedIn: "root"
})
export class UnsubscribeService {

  private httpClient: HttpClient;
  constructor(private httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(this.httpBackend);
  }

  postUnsubscribe(key: string): Observable<number> {
    const postData: PostUnsubscribeParametersDto = {
      key: key,
    }
    try {
      return this.httpClient.post<{
        data: any }>(`${environment.platformApiUrl}/UnsubscribeWeeklyReport/`, postData)
        .pipe(map(response => {
          return (response as any)?.unsubscribeStatus;
        }));
    } catch (ex) {
      return throwError(ex);
    }
  }
}

export interface IUnsubscribeStatusResponse { unsubscribeStatus: number }
